import { useMutation } from 'react-query';

import { changeClusterType as mutationFn } from 'api/endPoints/changeClusterType';

interface Params {
    projectId: number | undefined;
    clusterAbvs: number;
    clusterThreshold: number;
    minInCluster: number;
    clusterServiceType: string;
}

export const useMutationChangeNlpThresholds = () => {
    return useMutation((params: Params) => mutationFn(params));
};
